// Screen that tells the user that there are no recommended comps available for the subject.
import { Button, Flex, Typography } from '@aloft/toolkit-sui';

export function NoRecommendationsAvailable({
  body,
  getProperties,
}: {
  body: { status: 'not_found' } | { status: 'error'; message: string };
  getProperties: () => void;
}) {
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      gap="5rem"
      justifyContent="center"
      height="100%"
    >
      <Flex flexDirection="column" gap="1rem" alignItems="center">
        <Typography variant="h2">Recommended Comps Not Available</Typography>
        <Typography variant="body1">
          {body.status === 'error'
            ? 'An error occurred, no recommended comps are available for your subject property.'
            : "We are currently unable to recommend comps for this property. Either the the subject address is incorrect or we don't have data for this property."}
        </Typography>
        <Typography variant="body1">If you applied new filters, try removing them.</Typography>
        {body.status === 'error' && <Typography variant="body1">{body.message}</Typography>}
        {body.status === 'error' && <Button text={'Retry'} onClick={getProperties} />}
      </Flex>
    </Flex>
  );
}
